import { sectionTemplateFormToQuery as formToQuery } from './sectionTemplateFormToQuery';
import { sectionTemplateQueryToForm as queryToForm } from './sectionTemplateQueryToForm';

export default { formToQuery, queryToForm };
